"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onUpdateServiceRequest = exports.onSensorAlertAcknowledgedStateUpdated = exports.onUpdateSensorAlertBySensor = exports.onCreateSensorAlertBySensor = exports.onCreateSensorAlertByHub = exports.onCreateSensorAlert = exports.onCreateSensorEventBySensor = exports.onCreateSensorEventByHub = exports.onCreateSensorEvent = exports.onDeleteSensor = exports.onUpdateSensor = exports.onCreateSensor = exports.onDeleteHub = exports.onUpdateHub = exports.onCreateHub = void 0;
exports.onCreateHub = `
  subscription OnHubCreated {
    onHubCreated {
      id
      serialNumber
      macAddress
      name
      status
      hubType
      parentHubId
      installedAt
      installedBy
      installedByName
    }
  }
`;
exports.onUpdateHub = `
  subscription OnHubUpdated {
    onHubUpdated {
      id
      serialNumber
      macAddress
      name
      status
      latitude
      longitude
      config
      street
      city
      state
      zip
      logoUrl
      date
      time
      timezone
      hubType
      parentHubId
      installedAt
      installedBy
      installedByName
    }
  }
`;
exports.onDeleteHub = `
  subscription OnHubDeleted {
    onHubDeleted {
      id
      serialNumber
      macAddress
      name
      status
      hubType
      parentHubId
      installedAt
      installedBy
      installedByName
    }
  }
`;
exports.onCreateSensor = `
  subscription OnSensorCreated {
    onSensorCreated {
      id
      hubId
      serialNumber
      type
      name
      location
      sublocation
      status
      lastReported
      nodeId
      unid
      otaStatus
      otaProgress
      otaTargetVersion
      otaError
      otaUpdatedAt
      rssi
      rssiUpdatedAt
      installCompletedAt
      installCompletedBy
      installCompletedByName
    }
  }
`;
exports.onUpdateSensor = `
  subscription OnSensorUpdated {
    onSensorUpdated {
      id
      hubId
      serialNumber
      type
      version
      name
      location
      sublocation
      status
      lastReported
      nodeId
      unid
      otaStatus
      otaProgress
      otaTargetVersion
      otaError
      otaUpdatedAt
      rssi
      rssiUpdatedAt
      installCompletedAt
      installCompletedBy
      installCompletedByName
      branchCircuits {
        circuitNumber
        breakerNumber
        powerMonitorInputNumber
        breakerType
        breakerAmperage
        voltage
        location
        sublocation
        underCurrentAlert
        overCurrentAlert
        underCurrentAlertCustomAmps
        overCurrentAlertCustomAmps
      }
      equipmentDetails {
        type
        systemAge
        manufacturingDate
        manufacturer
        brand
        model
        serialNumber
        warrantyDuration
        notes
        systemType
        equipmentTonnage
        airFilterConfiguration {
          manufacturer
          modelNumber
          mervRated
          mervRating
          filterSizeHeight
          filterSizeWidth
          filterSizeDepth
          filterMaterial
          systemType
        }
        pressureConfiguration {
          staticPressureTarget
          supplyStaticPressure
          returnStaticPressure
          filterPressureDrop
          triggerAlertOnPressure
        }
        plenumConfiguration {
          shape
          widthInches
          heightInches
          diameterInches
          knownCFM
          airflowCalibrationFactor
        }
        photos {
          url
        }
        isVariableSpeed
        # Without it every live update dropped the client's copy, and forms
        # that prefill from the row fell back to 230V on a 115V install.
        systemVoltage
        compressorRLA
        compressorLRA
      }
      targetStaticPressure
      startingStaticPressure
      replacementDeltaInH2O
      pendingBaselineCapture
      baselineCapturedAt
      baselineCTAmps
      # A deleted row's unpairing (#3). Every mutation in onSensorUpdated's
      # @aws_subscribe list must select these too (subset rule).
      removal {
        reason
        requestedAt
        receivedAt
        result
        trigger
        closedAt
      }
      heldForRemovalOf
    }
  }
`;
exports.onDeleteSensor = `
  subscription OnSensorDeleted {
    onSensorDeleted {
      id
      hubId
      serialNumber
      type
      name
      location
      sublocation
      status
      lastReported
      nodeId
      unid
      otaStatus
      otaProgress
      otaTargetVersion
      otaError
      otaUpdatedAt
      rssi
      rssiUpdatedAt
      installCompletedAt
      installCompletedBy
      installCompletedByName
    }
  }
`;
exports.onCreateSensorEvent = `
  subscription OnSensorEventCreated {
    onSensorEventCreated {
      id
      timestamp
      sensorId
      hubId
      eventType
      value
      values
      metadata
    }
  }
`;
exports.onCreateSensorEventByHub = `
  subscription OnHubSensorEventCreated($hubId: ID!) {
    onHubSensorEventCreated(hubId: $hubId) {
      id
      timestamp
      sensorId
      hubId
      eventType
      value
      values
      metadata
    }
  }
`;
exports.onCreateSensorEventBySensor = `
  subscription OnSensorSensorEventCreated($sensorId: ID!) {
    onSensorSensorEventCreated(sensorId: $sensorId) {
      id
      timestamp
      sensorId
      hubId
      eventType
      value
      values
      metadata
    }
  }
`;
exports.onCreateSensorAlert = `
  subscription OnSensorAlertCreated {
    onSensorAlertCreated {
      id
      timestamp
      sensorId
      hubId
      alertType
      severity
      message
      value
      metadata
      status
      acknowledgedAt
      acknowledgedBy
      triggeredAt
      firstTriggeredAt
      lastTriggeredAt
      clearedAt
      clearedBy
      clearedByType
      clearedByName
    }
  }
`;
exports.onCreateSensorAlertByHub = `
  subscription OnHubSensorAlertCreated($hubId: ID!) {
    onHubSensorAlertCreated(hubId: $hubId) {
      id
      timestamp
      sensorId
      hubId
      alertType
      severity
      message
      value
      metadata
      status
      acknowledgedAt
      acknowledgedBy
      triggeredAt
      firstTriggeredAt
      lastTriggeredAt
      clearedAt
      clearedBy
      clearedByType
      clearedByName
    }
  }
`;
exports.onCreateSensorAlertBySensor = `
  subscription OnSensorSensorAlertCreated($sensorId: ID!) {
    onSensorSensorAlertCreated(sensorId: $sensorId) {
      id
      timestamp
      sensorId
      hubId
      alertType
      severity
      message
      value
      metadata
      status
      acknowledgedAt
      acknowledgedBy
      triggeredAt
      firstTriggeredAt
      lastTriggeredAt
      clearedAt
      clearedBy
      clearedByType
      clearedByName
    }
  }
`;
exports.onUpdateSensorAlertBySensor = `
  subscription OnSensorSensorAlertUpdated($sensorId: ID!) {
    onSensorSensorAlertUpdated(sensorId: $sensorId) {
      id
      timestamp
      sensorId
      hubId
      alertType
      severity
      message
      value
      metadata
      status
      acknowledgedAt
      acknowledgedBy
      triggeredAt
      firstTriggeredAt
      lastTriggeredAt
      clearedAt
      clearedBy
      clearedByType
      clearedByName
      durationSeconds
      serviceRequest {
        id
        status
        scheduledDate
      }
    }
  }
`;
exports.onSensorAlertAcknowledgedStateUpdated = `
  subscription OnSensorAlertAcknowledgedStateUpdated {
    onSensorAlertAcknowledgedStateUpdated {
      id
      sensorId
      hubId
      alertType
      status
      acknowledgedAt
      acknowledgedBy
      clearedAt
      clearedBy
      clearedByType
      clearedByName
      durationSeconds
    }
  }
`;
exports.onUpdateServiceRequest = `
  subscription OnServiceRequestUpdated {
    onServiceRequestUpdated {
      id
      hubId
      status
      scheduledDate
      alertId
    }
  }
`;
